import { render, staticRenderFns } from "./CollectionPerformanceZuzhang.vue?vue&type=template&id=3ee0a03f&scoped=true"
import script from "./CollectionPerformanceZuzhang.vue?vue&type=script&lang=js"
export * from "./CollectionPerformanceZuzhang.vue?vue&type=script&lang=js"
import style0 from "./CollectionPerformanceZuzhang.vue?vue&type=style&index=0&id=3ee0a03f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee0a03f",
  null
  
)

export default component.exports